<app-dialog-header *ngIf="!onWatchList" headerIcon="visibility" headerText="Watch List Info"
    (onCloseClick)="onCancelClick()"></app-dialog-header>
<div class="info-div" [ngClass]="{'adjusting-width': !onWatchList}" #infodiv>
    <div *ngIf="watchedData && watchedData.AssetID != 0 else NoData">
        <div style="display: flex;">
            <ng-template [ngTemplateOutlet]="newGrid"></ng-template>
            <span class="me-auto"></span>
            <div *ngIf="onWatchList">
                <button mat-raised-button *ngIf="watchedData" color="primary"
                    (click)="goToFunctionalLocation(watchedData.AssetID)">
                    <span>Functional Location</span>
                    <mat-icon>north_east</mat-icon>
                </button>
            </div>
        </div>
        <hr>
        <!-- <div *ngIf="!isMobileView then notMobile else mobile"></div> -->
        <div [ngTemplateOutlet]="notMobileNew"></div>
    </div>
    <ng-template #NoData>
        <div style="width: 100%; text-align: center;">
            <span style="font-weight: bold; font-size: larger;">Asset Not On Watch List</span><br>
            <span>If this asset is added to the Watch List, information about why it has been added can be seen here.</span>
        </div>
    </ng-template>
</div>

<ng-template #newGrid>
    <div class="watch-grid" [ngStyle]="{'grid-template-columns': numberOfTypes == 3 ? '1fr 1fr 1fr 1fr 1fr 1fr' 
    : numberOfTypes == 2 ? '1fr 1fr 1fr 1fr 1fr' : '1fr 1fr 1fr 1fr'}">
        <span class="heading">Asset Name</span>
        <span class="heading">Asset Description</span>
        <ng-container *ngIf="containsRuleEvents">
            <span class="heading centered">Rule Events</span>
        </ng-container>
        <ng-container *ngIf="containsDeviationEvents">
            <span class="heading centered">Deviation Events</span>
        </ng-container>
        <ng-container *ngIf="containsSensorEvents">
            <span class="heading centered">Offline Notifications</span>
        </ng-container>
        <span class="heading">Last Change</span>

        <span>{{watchedData.AssetName}}</span>
        <span>{{watchedData.AssetDescription}}</span>
        <ng-container *ngIf="containsRuleEvents && ruleHistory">
            <span class="centered">{{ruleHistory.length}}</span>
        </ng-container>
        <ng-container *ngIf="containsDeviationEvents && DeviationEvents">
            <span class="centered">{{DeviationEvents.length}}</span>
        </ng-container>
        <ng-container *ngIf="containsSensorEvents && offlineSensors">
            <span class="centered">{{offlineSensors.length}}</span>
        </ng-container>
        <span *ngIf="timeStamp">{{convertEpoch(timeStamp)}}</span>
    </div>
</ng-template>

<ng-template #notMobileNew>
    <div class="mobile-boxes">
        <ejs-tab id="element">
            <e-tabitems>
                <e-tabitem *ngIf="containsRuleEvents">
                    <ng-template #headerText>
                        <div class="alignRow">
                            <mat-icon>rule</mat-icon>&nbsp;Event History
                        </div>
                    </ng-template>
                    <ng-template #content>
                        <div [ngTemplateOutlet]="rulesBox"></div>
                    </ng-template>
                </e-tabitem>
                <e-tabitem *ngIf="containsDeviationEvents">
                    <ng-template #headerText>
                        <div class="alignRow">
                            <mat-icon>insights</mat-icon>&nbsp;Deviation History
                        </div>
                    </ng-template>
                    <ng-template #content>
                        <div [ngTemplateOutlet]="deviationsBox"></div>
                    </ng-template>
                </e-tabitem>
                <e-tabitem *ngIf="containsSensorEvents">
                    <ng-template #headerText>
                        <div class="alignRow">
                            <mat-icon>sensors</mat-icon>&nbsp;Offline Notifications
                        </div>
                    </ng-template>
                    <ng-template #content>
                        <div [ngTemplateOutlet]="sensorsBox"></div>
                    </ng-template>
                </e-tabitem>
            </e-tabitems>
        </ejs-tab>
    </div>
    <ng-template *ngIf="RelatedComments && RelatedComments.length > 0" [ngTemplateOutlet]="commentsBox"></ng-template>
</ng-template>

<ng-template #notMobile>
    <ng-template *ngIf="containsRuleEvents && !containsSensorEvents" [ngTemplateOutlet]="notMobileRules"></ng-template>
    <ng-template *ngIf="containsSensorEvents && !containsRuleEvents"
        [ngTemplateOutlet]="notMobileSensors"></ng-template>
    <ng-template *ngIf="containsRuleEvents && containsSensorEvents" [ngTemplateOutlet]="notMobileBoth"></ng-template>
</ng-template>

<ng-template #notMobileBoth>
    <div class="boxes-div">
        <ng-template [ngTemplateOutlet]="rulesBox"></ng-template>
        <ng-template [ngTemplateOutlet]="sensorsBox"></ng-template>
    </div>
    <ng-template *ngIf="RelatedComments && RelatedComments.length > 0" [ngTemplateOutlet]="commentsBox"></ng-template>
</ng-template>

<ng-template #notMobileRules>
    <div class="rule-box-div">
        <ng-template [ngTemplateOutlet]="rulesBox"></ng-template>
    </div>
    <ng-template *ngIf="RelatedComments && RelatedComments.length > 0" [ngTemplateOutlet]="commentsBox"></ng-template>
</ng-template>

<ng-template #notMobileSensors>
    <div class="rule-box-div">
        <ng-template [ngTemplateOutlet]="sensorsBox"></ng-template>
    </div>
    <ng-template *ngIf="RelatedComments && RelatedComments.length > 0" [ngTemplateOutlet]="commentsBox"></ng-template>
</ng-template>

<ng-template #mobile>
    <ng-template *ngIf="containsRuleEvents && !containsSensorEvents" [ngTemplateOutlet]="notMobileRules"></ng-template>
    <ng-template *ngIf="containsSensorEvents && !containsRuleEvents"
        [ngTemplateOutlet]="notMobileSensors"></ng-template>
    <ng-template *ngIf="containsRuleEvents && containsSensorEvents" [ngTemplateOutlet]="mobileBoth"></ng-template>
</ng-template>

<ng-template #mobileBoth>
    <div class="mobile-boxes">
        <ejs-tab id="element">
            <e-tabitems>
                <e-tabitem>
                    <ng-template #headerText>
                        <div class="alignRow">
                            <mat-icon>rule</mat-icon>&nbsp;Event History
                        </div>
                    </ng-template>
                    <ng-template #content>
                        <div [ngTemplateOutlet]="rulesBox"></div>
                    </ng-template>
                </e-tabitem>
                <e-tabitem>
                    <ng-template #headerText>
                        <div class="alignRow">
                            <mat-icon>sensors</mat-icon>&nbsp;Offline Notifications
                        </div>
                    </ng-template>
                    <ng-template #content>
                        <div [ngTemplateOutlet]="sensorsBox"></div>
                    </ng-template>
                </e-tabitem>
            </e-tabitems>
        </ejs-tab>
    </div>
    <ng-template *ngIf="RelatedComments && RelatedComments.length > 0" [ngTemplateOutlet]="commentsBox"></ng-template>
</ng-template>

<ng-template #rulesBox>
    <div>
        <div class="alignRow" style="display: flex;">
            <span style="font-size: larger; font-weight: bold;">Event History</span>
            <span class="me-auto"></span>
            <button mat-raised-button [disabled]="ruleEventsToAcknowledge.length == 0" (click)="acknowledge(true)"
                style="margin-bottom: 0.5em;">
                <span>Acknowledge</span>
                <mat-icon>done</mat-icon>
            </button>
            <button mat-raised-button [disabled]="ruleHistory.length == 0" (click)="addAllRuleEvents()"
                style="margin-bottom: 0.5em; margin-left: 0.5em;">
                <span>Select All</span>
            </button>
            <button mat-raised-button [disabled]="ruleHistory.length == 0" (click)="unAddAllRuleEvents()"
                style="margin-bottom: 0.5em; margin-left: 0.5em;">
                <span>Deselect All</span>
            </button>
        </div>
        <div class="history-item-rule-headings alignRow">
            <span>Rule Name</span>
            <span>Conditions</span>
            <span>Values</span>
            <span>Timestamp</span>
        </div>
        <ejs-listbox #listviewInstance [dataSource]='ruleHistory' [fields]="fieldsRule" height="50vh"
            cssClass='e-list-template'>
            <ng-template #itemTemplate let-dataSource>
                <div class="alignRow" style="overflow: hidden;">
                    <div class="history-item-rule-items alignRow ejs-listbox-item">
                        <div (click)="goToRuleEvent(dataSource)">{{dataSource.RuleName}}</div>
                        <div (click)="goToRuleEvent(dataSource)">{{dataSource.RuleText}}</div>
                        <div (click)="goToRuleEvent(dataSource)">{{dataSource.RuleValues}}</div>
                        <div (click)="goToRuleEvent(dataSource)">{{convertEpoch(dataSource.TimeStamp)}}</div>
                        <span class="alignColumn">
                            <mat-checkbox #ruleCheckboxes color="primary"
                                (change)="addRuleEventToAcknowledge(dataSource, $event)"></mat-checkbox>
                        </span>
                    </div>
                </div>
            </ng-template>
        </ejs-listbox>
    </div>
</ng-template>

<ng-template #sensorsBox>
    <div>
        <div class="alignRow" style="display: flex;">
            <span style="font-size: larger; font-weight: bold;">Offline Notifications</span>
            <span class="me-auto"></span>
            <button mat-raised-button [disabled]="sensorEventsToAcknowledge.length == 0" style="margin-bottom: 0.5em;"
                (click)="acknowledge(false)">
                <span>Acknowledge</span>
                <mat-icon>done</mat-icon>
            </button>
            <button mat-raised-button [disabled]="offlineSensors.length == 0" (click)="addAllSensorEvents()"
                style="margin-bottom: 0.5em; margin-left: 0.5em;">
                <span>Select All</span>
            </button>
            <button mat-raised-button [disabled]="offlineSensors.length == 0" (click)="unAddAllSensorEvents()"
                style="margin-bottom: 0.5em; margin-left: 0.5em;">
                <span>Deselect All</span>
            </button>
        </div>
        <div class="history-item-sensor-headings alignRow">
            <span>Sensor Name</span>
            <span>Timestamp</span>
        </div>
        <ejs-listbox #listviewInstance [fields]="fieldsSensor" [dataSource]='offlineSensors' height="50vh"
            cssClass='e-list-template'>
            <ng-template #itemTemplate let-dataSource>
                <div class="alignRow" style="overflow: hidden;">
                    <div class="history-item-sensor-items alignRow ejs-listbox-item">
                        <div (click)="goToOfflineEvent(dataSource)">{{dataSource.SensorName}}</div>
                        <div (click)="goToOfflineEvent(dataSource)">{{convertEpoch(dataSource.TimeStamp)}}</div>
                        <span>
                            <mat-checkbox #sensorCheckboxes color="primary"
                                (change)="addSensorEventToAcknowledge(dataSource, $event)"></mat-checkbox>
                        </span>
                    </div>
                </div>
            </ng-template>
        </ejs-listbox>
    </div>
</ng-template>

<ng-template #deviationsBox>
    <div>
        <div class="alignRow" style="display: flex;">
            <span style="font-size: larger; font-weight: bold;">Deviation History</span>
            <span class="me-auto"></span>
            <button mat-raised-button [disabled]="deviationEventsToAcknowledge.length == 0"
                style="margin-bottom: 0.5em;" (click)="acknowledge(true, true)">
                <span>Acknowledge</span>
                <mat-icon>done</mat-icon>
            </button>
            <button mat-raised-button [disabled]="DeviationEvents.length == 0" (click)="addAllDeviationEvents()"
                style="margin-bottom: 0.5em; margin-left: 0.5em;">
                <span>Select All</span>
            </button>
            <button mat-raised-button [disabled]="DeviationEvents.length == 0" (click)="unAddAllDeviationEvents()"
                style="margin-bottom: 0.5em; margin-left: 0.5em;">
                <span>Deselect All</span>
            </button>
        </div>
        <div class="history-item-deviation-headings alignRow">
            <span>DataPoint</span>
            <span>Tolerance</span>
            <span>Sensitivty</span>
            <span>Timestamp</span>
        </div>
        <ejs-listbox #listviewInstance [fields]="fieldsDeviation" [dataSource]='DeviationEvents' height="50vh"
            cssClass='e-list-template'>
            <ng-template #itemTemplate let-dataSource>
                <div class="alignRow" style="overflow: hidden;">
                    <div class="history-item-deviation-items alignRow ejs-listbox-item">
                        <div (click)="goToDeviationEvent(dataSource)">{{dataSource.DPTitle}}</div>
                        <div (click)="goToDeviationEvent(dataSource)">{{dataSource.AcceptableDeviation}}</div>
                        <div (click)="goToDeviationEvent(dataSource)">{{dataSource.Sensitivity}}</div>
                        <div (click)="goToDeviationEvent(dataSource)">{{convertEpoch(dataSource.Timestamp)}}</div>
                        <span>
                            <mat-checkbox #deviationCheckboxes color="primary"
                                (change)="addDeviationEventToAcknowledge(dataSource, $event)"></mat-checkbox>
                        </span>
                    </div>
                </div>
            </ng-template>
        </ejs-listbox>
    </div>
</ng-template>

<ng-template #commentsBox>
    <div style="padding-top: 2em; padding-left: 1em; padding-right: 1em;">
        <span style="font-size: larger; font-weight: bold; margin-bottom: 0.5em;">Related Comments</span>
        <span *ngIf="!RelatedComments || RelatedComments.length == 0"><br>This section will display any comments that
            have
            been left on Events related to this asset.</span>
        <div *ngIf="RelatedComments && RelatedComments.length > 0" class="comment-item-heading">
            <span>Comment Text</span>
            <span>Timestamp</span>
            <span>Added By</span>
        </div>
        <ejs-listview *ngIf="RelatedComments && RelatedComments.length > 0" [dataSource]='RelatedComments'
            cssClass="e-list-template" height="15vh">
            <ng-template #template let-dataSource>
                <div class="ejs-listview-item comment-item-items" (click)="goToCommentEvent(dataSource)">
                    <span>{{dataSource.CommentText}}</span>
                    <span>{{convertEpoch(dataSource.Timestamp)}}</span>
                    <span >{{dataSource.UserID}}</span>
                </div>
            </ng-template>
        </ejs-listview>
    </div>
</ng-template>